import RootRouter from './routes/RootRouter'
import CustomStoreProvider from './store/StoreProvider'

function App() {
  return (
    <CustomStoreProvider>
      <RootRouter />
    </CustomStoreProvider>
  )
}

export default App
